const calculatePercentage = (value: number, total: number): number => {
	if (total === 0) {
		throw new Error("O total não pode ser zero.");
	}

	return (value / total) * 100;
};

export { calculatePercentage }